import type { ReactNode } from 'react';
import styles from './Badge.module.scss';

type Tone = 'neutral' | 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'muted';

interface BadgeProps {
  tone?: Tone;
  children: ReactNode;
  dot?: boolean;
  className?: string;
}

export function Badge({ tone = 'neutral', children, dot, className }: BadgeProps) {
  const classes = [styles.badge, styles[`tone_${tone}`], className].filter(Boolean).join(' ');
  return (
    <span className={classes}>
      {dot && <span className={styles.dot} />}
      {children}
    </span>
  );
}
